// No React here: the hidden Miro app page uses it too, and stays small.

/**
 * A part of the site that could not be loaded because the site was deployed
 * again while this page was open (2026-10-27): the page asks for script files
 * by the names its own build gave them. DEPLOY-WEB.bat keeps earlier builds'
 * files online for 30 days, so this should not happen; if it ever does, the
 * page says what it is and offers a reload rather than an error.
 */
export function isStaleBuildError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return /dynamically imported module|Importing a module script failed|Unable to preload CSS|Loading (CSS )?chunk|ChunkLoadError/i.test(
    message,
  )
}
